// widgetFormat.js — Mini Row 위젯 공용 포맷 헬퍼 (2026-06-06)
//
// 목표: 금액은 천단위 콤마 + "원" 으로 정확히 표기 (사용자 명세).
// 모바일 2열에서 잘림 방지는 width='wide' (col-span-2) 로 해결.
// 라벨 truncate 허용 / 데이터(숫자) truncate 절대 금지.
//
// 디자인 원칙:
//   - 금액은 절대 축약하지 않음. "2,760,730원" 처럼 정확히 표기.
//   - 잘림이 걱정되는 위젯은 spec 의 width 를 WIDE 로 둔다.
//   - 음수 부호 보존 (예: -50,000원).
//
// width 분류:
//   - 'narrow': 모바일 2열 그대로 (col-span-1).
//   - 'wide':   모바일 1열 차지 (col-span-2). 데스크탑은 그대로 1셀.

const fmt = (n) => Number(n || 0).toLocaleString();

// 정확한 원화 (잘림 보호용으로는 사용 금지, 컨텍스트에 따라)
export const fmtWon = (n) => `${fmt(n)}원`;

/**
 * formatCompactKrw — 천단위 콤마 + "원" 정확 표기 (2026-06-06 명세 변경).
 *   0           → "0원"
 *   1 ~          → "N,NNN,NNN원"   (toLocaleString 기준)
 *   음수        → "-N,NNN,NNN원"   (부호 보존)
 * 과거에는 만/억 단위 축약을 했지만, 사용자 결정으로 정확 표기로 통일.
 * 이름은 호환을 위해 유지 (호출부 변경 불필요).
 */
export function formatCompactKrw(value) {
  const n = Math.round(Number(value) || 0);
  if (n === 0) return '0원';
  const sign = n < 0 ? '-' : '';
  const abs = Math.abs(n);
  return `${sign}${fmt(abs)}원`;
}

/**
 * formatCompactCount — 큰 카운트도 축약 (선택적).
 *   N < 10,000 → "N"
 *   N >= 10,000 → "N.N만"
 */
export function formatCompactCount(value) {
  const n = Math.round(Number(value) || 0);
  if (Math.abs(n) < 10000) return fmt(n);
  const v = n / 10000;
  const s = (Math.abs(v) >= 10 || Number.isInteger(v)) ? Math.round(v).toString() : v.toFixed(1);
  return `${s}만`;
}

/**
 * truncateName — 사람 이름 너무 길면 단축 (3자 + 외 N명 등).
 *   2자 이하 → 그대로
 *   3자 → 그대로
 *   4자 이상 → 앞 3자.
 */
export function truncateName(name, max = 4) {
  const s = String(name || '');
  if (s.length <= max) return s;
  return s.slice(0, max);
}

/**
 * dashIfNull — null 표시
 */
export const dashIfNull = (v) => (v == null || v === '' ? '-' : v);

/**
 * widthFor — 위젯 폭 분류 (narrow/wide).
 * Mini Row 그리드는 width === 'wide' 이면 모바일에서 col-span-2.
 * spec 객체에 width 필드를 통일하여 표기.
 */
export const WIDTHS = Object.freeze({ NARROW: 'narrow', WIDE: 'wide' });
